<template>
  <!-- <router-view></router-view> -->
  <div>
    <projectInlet></projectInlet>
  </div>
</template>

<script>
document.title = '北京市交通委员会运政管理专用域名';
import projectInlet from './components/index.vue'
export default {
  name: 'App',
  components: {
    // HelloWorld
    projectInlet
  }
}
</script>

<style>
#app {
  height: 100%;
  width: 100%;
  position: absolute;
}
</style>
